
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { listadoCentrosSelect, startCentroXID, startListadoCentros, startListConsumoCentro } from "../../../services";





export const useCentroCostoXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['centro-id', id], 
        queryFn: () => startCentroXID(id),
        enabled: id !== "new",
    });

    return { data, isLoading }
}




export const useCentroCostoSelect = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['centros-select'], 
        queryFn: () => listadoCentrosSelect(),
    });

    return { data, isLoading }
}





export const useCentrosCostoQuery = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['list-cencos', { page, termino }], 
        queryFn: () => startListadoCentros({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}






export const useConsumoCentrosCosto = (id) => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['list-consumos-cencos', { page, termino, id }], 
        queryFn: () => startListConsumoCentro({ page, termino, id }),
        enabled: !!id,
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}
